import React, { useContext } from 'react';
import { useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import { TabInfoContext } from '../../contexts/tab-info.context';
import { GlobalContext } from '../../contexts/global.context';

import NavDrawer from './nav-drawer.component';
import NavBar from './nav-bar.component';

import './nav.styles.scss';

export default function Nav() {
  const theme = useTheme();
  const { selectedTab, selectedSubTab, handleUpdate } = useContext(GlobalContext);
  const { navInfo } = useContext(TabInfoContext);
  let navigate = useNavigate();

  function handleSelect(newTab, newSubTab) {
    if (newSubTab !== 'Coming soon...') {
      if (newTab === 'Home' || newTab === 'About') {
        navigate(`/${newTab.toLowerCase().split(' ').join('-')}`);
      } else {
        navigate(`/${newTab.toLowerCase().split(' ').join('-')}/${newSubTab.toLowerCase().split(' ').join('-')}`);
      }
      handleUpdate('nav', { newTab, newSubTab });
    }
  }

  return (
    <nav style={{ '--primary-color': theme.palette.primary.main, '--secondary-color': theme.palette.secondary.main }}>
      <div id='nav-drawer'>
        <NavDrawer
          navInfo={navInfo}
          selectedGroup={selectedTab}
          selectedOption={selectedSubTab}
          handleSelect={handleSelect}
        />
      </div>

      <div id='nav-bar'>
        <NavBar
          navInfo={navInfo}
          selectedGroup={selectedTab}
          selectedOption={selectedSubTab}
          handleSelect={handleSelect}
        />
      </div>
    </nav>
  );
}